<template>
    <el-dialog
            title="素材列表"
            :visible.sync="dialogVisible"
            :show="show"
            @close="handleClose"
            width="1000px"
            :append-to-body="true"
            class="operate-el-dialog">
        <el-row :gutter="10" v-loading="loading">
            <el-col :span="4" class="el-col-image" v-for="(item,index) in images" :key="index"
                    @click.native="click(item,index)">
                <el-card class="el-card" shadow="always" :class="{elColSelect: itemSelectStatus[index]}"
                         body-style="padding : 0 0">
                    <el-image :src="item.url"/>
                    <div style="padding: 10px 10px;background-color: cornflowerblue;">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                            <span class="image-name">{{format(item.name)}}</span>
                        </el-tooltip>
                        <div>
                            <span class="image-time">{{formatDate(item.update_time)}}</span>
                        </div>
                    </div>

                    <el-button class="el-button-select" v-if="itemSelectStatus[index]" type="success"
                               icon="el-icon-check" circle/>
                </el-card>
            </el-col>
        </el-row>
        <div class="bottom-div">
            <el-pagination
                    class="el-pagination"
                    background
                    layout="prev, pager, next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="param.count"
                    :pager-count="5"
                    :total="param.totalCount">
            </el-pagination>
            <el-button type="primary" class="confirm" @click="conClick">确认</el-button>
        </div>

    </el-dialog>
</template>

<script>
    export default {
        name: "ImageShowDialog",
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        show() {
            this.dialogVisible = this.show;
        },
        data() {
            return {
                dialogVisible: this.show,
                param: {
                    type: "image",
                    offset: 0,
                    count: 18,
                    totalCount: 0
                },
                loading: false,
                currentPage: 1,
                currentItem: {},
                images: [],
                replacePngToJpg: this.$StringUtils.replacePngToJpg,
                itemSelectStatus: [],
            }
        },
        methods: {
            handleClose() {
                this.$emit('update:show', false);
            },
            imageInfos() {
                this.loading = true;
                this.$api.material.batchGetMaterial(this.param).then(data => {
                    this.param.totalCount = data.total_count;
                    this.images = data.item;
                    this.fillSelectStatus(this.images.length);
                    this.loading = false;
                });
            },
            format(str) {
                return this.$StringUtils.splice(str, 10);
            },
            click(item, index) {
                this.currentItem = item;
                this.fillSelectStatus(this.images.length);
                this.itemSelectStatus[index] = true;
            },
            formatDate(str) {
                return this.$DateUtis.StringToDate(str, "yyyy-MM-dd hh:mm:ss");
            },
            fillSelectStatus(len) {
                this.itemSelectStatus = new Array(len).fill(false);
            },
            handleCurrentChange(val) {
                this.param.offset = (val - 1) * this.param.count;
                this.currentPage = val;
                this.imageInfos();
            },
            handleSizeChange(val) {
                this.param.count = val;
                this.imageInfos();
            },
            conClick() {
                this.$emit("itemClick", this.currentItem);
                this.dialogVisible = false;
            }
        },
        mounted() {
            this.imageInfos();
        }
    }
</script>

<style scoped>
    .el-col {
        margin-bottom: 10px;
    }

    .el-image {
        height: 140px;
        width: 100%;
        display: block;
    }

    .image-name {
        font-size: 12px;
        width: 100%;
    }

    .image-time {
        font-size: 12px;
        width: 100%;
    }

    .el-col-image {
        /*float: left;*/
        /*width: 20%;*/
        position: relative;
    }

    .elColSelect {
        border: 2px solid #67c23a !important;
    }

    .el-card {
        border: 2px solid #EBEEF5
    }

    .el-button-select {
        position: absolute;
        top: 0;
        right: 5px;
    }

    .confirm {
        position: absolute;
        right: 0;
        top: 0;
    }

    .el-pagination {
        width: 20px;
    }

    .bottom-div {
        width: 100%;
        position: relative;
    }
</style>